import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
    className as _$cn,
} from 'intact';
import {Sender, Button, Dialog, Radio, Input, Icon} from 'kpc';

var _$tmp0 = {
    'className': 'k-icon-add-bold'
};
var _$tmp1 = {
    'type': 'file',
    'multiple': true
};
var _$tmp2 = {
    'style': 'margin-top: 16px;'
};
var _$tmp3 = {
    'style': 'margin-top: 16px;'
};

export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Sender, {
            'uploadButton': 'list',
            'fileView': 'media',
            'uploadProps': this.getUploadProps(),
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['uploadButton'] = function($super, scope) {
                            return (
                                _$ce(2, 'div', [
                                    _$cc(Icon, _$tmp0),
                                    _$ce(2, 'div', '添加附件', 16, 'sender-custom-attachment-upload-text')
                                ], 4, _$cn({
                                    'sender-custom-attachment-upload': true,
                                    'sender-custom-attachment-upload-disabled': scope.disabled || scope.reachLimit,
                                }), {
                                    'ev-click': this.openDialog.bind(this, scope),
                                    'role': 'button',
                                    'title': '添加附件',
                                    'aria-label': '添加附件'
                                })
                            );
                        }),
                        (__$blocks['uploadButton'] = function($super, data) {
                            var block = $blocks['uploadButton'];
                            var callBlock = function() {
                                return _$blocks['uploadButton'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em),
            'ev-$model:value': function($v) {
                $this.set('value', $v);
            },
            'value': $this.get('value'),
            'ev-$model:attachments': function($v) {
                $this.set('attachments', $v);
            },
            'attachments': $this.get('attachments')
        }),
        _$cc(Dialog, {
            'title': '添加参考内容',
            'ok': this.confirmAttachment,
            'children': (
                _$ce(2, 'div', [
                    _$cc(Radio, {
                        'trueValue': 'file',
                        'children': '本地文件',
                        'ev-$model:value': function($v) {
                            $this.set('mode', $v);
                        },
                        'value': $this.get('mode')
                    }),
                    _$cc(Radio, {
                        'trueValue': 'url',
                        'children': 'URL',
                        'ev-$model:value': function($v) {
                            $this.set('mode', $v);
                        },
                        'value': $this.get('mode')
                    }),
                    (this.get('mode') === 'file') ?
                        _$ce(2, 'div', (
                            _$ce(64, 'input', null, 1, null, _$tmp1, null, (i) => this.fileInput = i)
                        ), 2, null, _$tmp2) :
                        _$ce(2, 'div', (
                            _$cc(Input, {
                                'placeholder': 'https://example.com/image.png',
                                'ev-$model:value': function($v) {
                                    $this.set('url', $v);
                                },
                                'value': $this.get('url')
                            })
                        ), 2, null, _$tmp3)
                ], 4, 'sender-custom-attachment-dialog')
            ),
            'ev-$model:value': function($v) {
                $this.set('dialogVisible', $v);
            },
            'value': $this.get('dialogVisible')
        })
    ], 4);
};